export default __webpack_public_path__ + "static/media/Background_00017.27949693.png";